export const getStructuredJson = (
  formattedUpdatedAt,
  canonicalLink,
  metaTitle,
  verticalName,
  metaDescription,
  structuredData
) => {
  const structuredJSON = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    dateModified: formattedUpdatedAt,
    datePublished: formattedUpdatedAt,
    url: canonicalLink,
    name: metaTitle,
    headline: verticalName,
    description: metaDescription,
    author: {
      '@type': 'Organization',
      name: structuredData?.name,
      url: structuredData?.url,
    },
    publisher: {
      '@type': 'Organization',
      name: structuredData?.name,
      url: structuredData?.url,
    },
  };

  if (!verticalName) {
    delete structuredJSON.headline;
  }

  return JSON.stringify(structuredJSON);
};

export const getStructuredFaqJson = ({ faqs, faqSeoIndexes }) => {
  const useForSeoQuestions = faqs.filter((faq, index) => faqSeoIndexes?.includes(index + 1));
  if (useForSeoQuestions.length < 1) {
    return '';
  }
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: useForSeoQuestions.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  });
};

export default {
  getStructuredJson,
  getStructuredFaqJson,
};
